// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KRYv","footer":"styles_footer__DiRKa","passCodeTooltip":"styles_passCodeTooltip__-c8jM"};